import React from "react";
import { Button } from "@mui/material";
import { IAddButton, ButtonVariant } from "./ButtonInterfaces";

export default function ButtonCustom({
  //Propiedade que vai dentro do botão, aceita qualquer item, inclusive Icones
  children,
  onClick,
  typeButton,
  sx,
  fullWidth = false,
}: IAddButton) {
  const buttonStyle = {
    backgroundColor: typeButton === "contained" ? "#1976d2 !important" : "",
    color: "white",
    margin: 1,
  };

  return (
    <Button
      variant={typeButton}
      onClick={onClick}
      fullWidth={fullWidth}
      sx={{ ...buttonStyle, ...sx }}
    >
      {children}
    </Button>
  );
}
